module.exports = __webpack_public_path__ + "static/coqui_license_explainer-593355ed0d5ddf49e5a8b25e98e160d3.webm";